import { API_V4 } from "@/services/config/auth-axios";

class UserService {
  updateUsername(username) {
    return API_V4.post("/verification/users/username/update", {
      username
    });
  }

  getInfo() {
    return API_V4.get("/accounts/user-information");
  }

  getVerifyInfo() {
    return API_V4.get("/accounts/user-verify-information");
  }

  setSetting(data) {
    return API_V4.post("/users/setting", data);
  }

  getSetting() {
    return API_V4.get("/users/setting");
  }

  updateInfo(data) {
    const { firstName, lastName, nationalCode, birthDate } = data;
    return API_V4.post("/verification/users/personal-information/update", {
      first_name: firstName,
      last_name: lastName,
      national_code: nationalCode,
      // gender,
      birth_date: birthDate
    });
  }

  personalInformationUpdate(data) {
    const {
      otp,
      mobile,
      national_code,
      first_name,
      last_name,
      birth_date
    } = data;
    return API_V4.post("/verification/users/personal-information/update", {
      otp: otp,
      mobile: mobile,
      national_code: national_code,
      first_name: first_name,
      last_name: last_name,
      birth_date: birth_date
    });
  }

  autoVerificationCancellation() {
    return API_V4.post("/verification/cancel/auto", {});
  }

  shahkar(data) {
    const { mobile, national_code } = data;
    return API_V4.post("/verification/mobile/check", {
      mobile: mobile,
      national_code: national_code
    });
  }
  thirdPartyKyc() {
    return API_V4.get("verification/auto-kyc");
  }

  getUserTypeForKyc() {
    return API_V4.get("/verification/kyc/types");
  }

  userKycVerification(data) {
    return API_V4.post("/verification/kyc/user-info", data);
  }

  getTypeOfKyc() {
    return API_V4.get("verification/kyc/user-type");
  }
  submitKycMethodForUser(data) {
    return API_V4.post("verification/kyc/user-method", data);
  }
  getAttachments() {
    return API_V4.get("/verification/kyc/attachments");
  }
  uploadFile(data) {
    return API_V4.post("/verification/kyc/attachments", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  getOtpType() {
    return API_V4.get("/verification/otp-settings/type")
  }
  changeOtpType(data) {
    return API_V4.post("/verification/otp-settings/type", data)
  }
}

export default new UserService();
